import React from 'react'
import Residuos from './ResiduoRejeito';
import ResiduosPendentes from './ResiduoRejeitoSigor';
import Filter from '../../../Auxiliar/Filter';
import { useSelector } from 'react-redux';

const SelecionarJsRR = () => {
    const permission = useSelector(state => state.AppReducer.permissoes.sigor.acesso)

    const [search, setSearch] = React.useState(false)
    const [dateOf, setDateOf] = React.useState('')
    const [dateFor, setDateFor] = React.useState('')
    const [options, setOptions] = React.useState({
        residuo: { value: true, label: 'Resíduos/Rejeitos Finalizados', checked: true },
        residuoPendente: { value: false, label: 'Resíduos/Rejeitos Pendentes(SIGOR)', checked: false, disabled: !permission },
    })

    return (
        <div className="card">
            <div className="card-body" id="card">
                <div className="d-flex align-items-start">
                    <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>Resíduos</h4>
                    <Filter setDateOf={setDateOf} setDateFor={setDateFor} options={options} setOptions={setOptions} setSearch={setSearch} />
                </div>
                <div>
                    <p style={{ fontSize: '1rem', color: 'black' }}>Aqui são listados os resíduos do sistema</p>
                </div>
                <div className="row">
                    {options.residuo.value &&
                        <Residuos dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} />}
                    {options.residuoPendente.value &&
                        <ResiduosPendentes dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} />}
                </div>
            </div>
        </div>
    )
}

export default SelecionarJsRR